import { AxiosInstance } from 'axios'
import { MediaObject } from '../types'

export interface GetSpecialistsArgs {
  locale: string
}

type SpecialistsDto = {
  data: {
    id: number
    attributes: {
      our_specialists_title: string
      our_specialists_button_text: string
      specialists: {
        data: SpecialistDto[]
      }
    }
  }
  meta: Record<string, unknown>
}

type SpecialistDto = {
  id: number
  attributes: {
    name: string
    slug: string
    order: number
    academic_degree: string | null
    photo: MediaObject | null
    specialties: {
      data: {
        id: number
        attributes: {
          name: string
        }
      }[]
    }
  }
}

export const getSpecialists = async (
  client: AxiosInstance,
  { locale }: GetSpecialistsArgs,
): Promise<SpecialistsDto['data']['attributes']> => {
  const path = `/home-page`
  const params = {
    locale,
    fields: ['our_specialists_title', 'our_specialists_button_text'],
    populate: {
      specialists: {
        fields: ['name', 'slug', 'order', 'academic_degree'],
        populate: {
          photo: {
            populate: '*',
          },
          specialties: {
            fields: ['name'],
          },
        },
      },
    },
  }
  return (await client.get<SpecialistsDto>(path, { params })).data.data.attributes
}
